import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    subTitle: {
        fontSize: '1.4em',
        marginTop: theme.spacing(.5),
    },
}));

function EmployeeInformation({ name, employeeId, seniorityDate, domicile }) {
    const classes = useStyles();

    return (
        <>
        <div className={classes.subTitle}>Employee Information</div>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
                <TextField
                    label="Name"
                    name="name"
                    value={name}
                    margin="dense"
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <TextField
                    label="Employee Number"
                    name="employeeId"
                    value={employeeId}
                    margin="dense"
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <TextField
                    label="Seniority Date"
                    name="seniorityDate"
                    value={seniorityDate}
                    margin="dense"
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <TextField
                    label="Domicile"
                    name="domicile"
                    value={domicile}
                    margin="dense"
                    fullWidth
                    disabled
                />
            </Grid>
        </Grid>
        </>
    );
};

EmployeeInformation.propTypes = {
    name: PropTypes.string.isRequired,
    employeeId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
    seniorityDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
      ]).isRequired,
    domicile: PropTypes.string.isRequired,
};

export default EmployeeInformation;
